import { Download, FileSpreadsheet, FileText } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { api, errorMessage } from '@/lib/api';

export interface ExportOption {
  label: 'Planilha (XLSX)' | 'PDF';
  path: string;
  query?: Record<string, string | number | boolean | null | undefined>;
  filename: string;
}

/** Menu "Exportar" com download de planilha e PDF. Cada opção leva os filtros ativos da tela. */
export function ExportMenu({ options, disabled }: { options: ExportOption[]; disabled?: boolean }) {
  const [busy, setBusy] = useState<string | null>(null);
  const run = async (o: ExportOption) => {
    setBusy(o.label);
    try {
      await api.download(o.path, o.query, o.filename);
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(null);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled || busy !== null}>
          <Download className="size-4" aria-hidden /> {busy ? 'Exportando…' : 'Exportar'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {options.map((o) => (
          <DropdownMenuItem key={o.label} onSelect={() => void run(o)}>
            {o.label === 'PDF' ? <FileText className="size-4" aria-hidden /> : <FileSpreadsheet className="size-4" aria-hidden />} {o.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
